import { IVehicleModel } from 'app/shared/model/vehicle-model.model';
import { TireFunction } from 'app/shared/model/enumerations/tire-function.model';

const extractTireFunctionMap = (vehicleModel?: IVehicleModel | null): Record<string, TireFunction> => {
  const rawTireFunction = vehicleModel?.tireFunction as Record<string, unknown> | undefined | null;
  const map = (rawTireFunction?.['map'] ?? rawTireFunction ?? {}) as Record<string, TireFunction>;
  return map;
};

export const isVehicleModelTireFunctionComplete = (vehicleModel: IVehicleModel | null | undefined, numberOfTires: number): boolean => {
  if (!vehicleModel || !numberOfTires) {
    return false;
  }

  const map = extractTireFunctionMap(vehicleModel);

  for (let position = 1; position <= numberOfTires; position++) {
    const tireFunction = map[position] ?? map[String(position)];
    if (tireFunction == null || tireFunction === TireFunction.NULL) {
      return false;
    }
  }

  return true;
};
